// extracted by mini-css-extract-plugin
module.exports = {"root":"m-singlex_item__3FPOij_f"};